export default __webpack_public_path__ + "static/media/img_cty2.df76382f.png";